export const isBrowser = typeof window !== 'undefined';

export const isApp = () => {
  if (isBrowser) {
    return /bybit_app/.test(navigator.userAgent.toLowerCase());
  }
  return false;
};

export const isMobile = () => {
  if (isBrowser) {
    return /(ipod|ipad|iphone|android|mobile)/.test(
      navigator.userAgent.toLowerCase()
    );
  }
  return false;
};

export const isPC = () => {
  if (isBrowser) {
    const ua = navigator.userAgent;
    const isAndroid = /(?:Android)/.test(ua);
    const isFireFox = /(?:Firefox)/.test(ua);
    const isTablet =
      /(?:iPad|PlayBook)/.test(ua) ||
      (isAndroid && !/(?:Mobile)/.test(ua)) ||
      (isFireFox && /(?:Tablet)/.test(ua));
    const isIPhone = /(?:iPhone)/.test(ua) && !isTablet;

    return !isIPhone && !isAndroid;
  }
  return false;
};
